import React from "react";

import { useHistory } from "react-router";

import { Wrapper } from "./styles";
import { paletas } from "../../styles/theme";
import { useApp } from "../../contexts";
import { Loading, Mensagem } from "../../componentes";
import { CarregarDadosUsuario } from "../../servicos";

export default function Autenticacao() {
  let history = useHistory();
  const { setUsuarioCorrente } = useApp();
  const [mensagem, setMensagem] = React.useState("");

  // Carregar dados de usuário
  const carregarDadosUsuario = React.useCallback(async () => {
    try {
      const verificaStorage = localStorage.getItem("@batalha-dev/autenticado");
      const dadosLocais = verificaStorage && JSON.parse(verificaStorage);

      if (dadosLocais.token) {
        let dados = await CarregarDadosUsuario(dadosLocais.email);

        setUsuarioCorrente(dados);
        return history.push("/home");
      } else {
        setMensagem("Token expirado ou não encontrado!");
        setTimeout(() => {
          history.push("/login");
        }, 3000);
      }
    } catch (err) {
      history.push("/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  React.useEffect(() => {
    carregarDadosUsuario();
  }, [carregarDadosUsuario]);

  return (
    <Wrapper>
      <Loading loading={true} cor={paletas.DarkOrange}>
        {}
      </Loading>
      {mensagem ? <Mensagem tipo="erro" frase={mensagem} /> : null}
    </Wrapper>
  );
}
